var map = {
	"./MBudget.svg": 1247,
	"./Mtel.svg": 1165,
	"./Quickline.svg": 1158,
	"./Salt.svg": 1155,
	"./Spusu.svg": 1166,
	"./Swisscom.svg": 1153,
	"./TalkTalk.svg": 1159,
	"./Wingo.svg": 1154,
	"./migros.svg": 1157,
	"./yallo.svg": 1156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1246;